module.exports = __webpack_public_path__ + "img/轮播3.19e1d432.png";